import { render, staticRenderFns } from "./CreatePurchaseOrder.vue?vue&type=template&id=5ecd1a2e"
import script from "./CreatePurchaseOrder.vue?vue&type=script&lang=js"
export * from "./CreatePurchaseOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports